<template>
  <div class="datepicker" :id="rand" :class="{label: label}">
    <div class="selectable" :class="{focus: open, notnull: fromDate}">
      <span @click="open = !open">
        {{ fromDate ? getDate(fromDate) : open || label ? data.placeholder : '' }}
      </span>
      <CalendarIcon class="icon" v-if="!fromDate" @click="open = !open"/>
      <ClosedIcon class="icon" v-if="fromDate" @click="fromDate = null; open = false" />
    </div>
    <div class="title" v-if="data.label && !label">
      {{ data.label }}
    </div>
    <transition name="top-fade">
      <div class="calendar" v-if="open" :class="{right: right}">
        <div class="header">
          <div class="month">
            {{ date ? months[date.getMonth()] : ''}}, {{date ? date.getFullYear() : ''}}
          </div>
          <div class="controll">
            <ChevronLeftIcon class="icon" @click="prevMonth" />
            <ChevronRightIcon class="icon" @click="nextMonth" />
          </div>
        </div>
        <div class="weeks">
          <div v-for="(week, i) in weeks" :key="'week' + i">
            {{ week }}
          </div>
        </div>
        <div class="days">
          <div v-for="(day, i) in fromDays" :key="'from' + i" :class="[day.class]">
            <span @click="setDate(date, day)">
              {{day.day}}
            </span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CalendarIcon from '@/assets/svg/calendar-icon.svg?inline'
import ClosedIcon from '@/assets/svg/closed-icon.svg?inline'
import ChevronLeftIcon from '@/assets/svg/chevron-left-icon.svg?inline'
import ChevronRightIcon from '@/assets/svg/chevron-right-icon.svg?inline'

export default{
  components: {
    CalendarIcon,
    ClosedIcon,
    ChevronLeftIcon,
    ChevronRightIcon
  },
  props: {
    data: Object,
    right: Boolean,
    value: Number,
    label: Boolean
  },
  data () {
    return {
      open: false,
      fromDate: null,
      months: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
      weeks: ['пн','вт','ср','чт','пт','сб','вс'],
      date: null,
      fromDays: [],
      selects: {
        from: [],
        to: [],
      },
      rand: null
    }
  },
  computed: {
    getFromDate () {
      return this.date
    }
  },
  watch: {
    fromDate (val) {
      this.fromDays = this.getDays(this.date)
      this.$emit('set', val ? val.getTime() : null)
    },
    value (val) {
      if (!val) {
        this.fromDate = null
      } else {
        this.date = new Date(Number(val))
        this.fromDate = new Date(Number(val))
        this.fromDays = this.getDays(this.date)
      }
    }
  },
  methods: {
    prevMonth () {
      const newDate = new Date(this.date)
      newDate.setMonth(newDate.getMonth() - 1)
      this.date = newDate
      this.fromDays = this.getDays(this.getFromDate)
    },
    nextMonth () {
      const newDate = new Date(this.date)
      newDate.setMonth(newDate.getMonth() + 1)
      this.date = newDate
      this.fromDays = this.getDays(this.getFromDate)
    },
    getDate (date) {
      if (date) {
        return (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) + '.' + ((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '.' + date.getFullYear()
      }
    },
    setDate (date, day) {
      if (day.class === '') {
        const newDate = new Date(date)
        newDate.setDate(day.day)
        this.fromDate = newDate
        this.open = false
      }
    },
    getDays (date, days = []) {
      if (date) {
        const newDate = new Date(date.getFullYear(), date.getMonth(), 1)
        let totalDate = new Date(date.getFullYear(), date.getMonth(), 32)
        totalDate.setMonth(totalDate.getMonth() - 1)
        totalDate = 32 - totalDate.getDate()
        const endWeek = newDate.getDay() === 0 ? 6 : newDate.getDay() - 1
        for (let i = (totalDate - endWeek) + 1; i <= totalDate; i++) {
          days.push({day: i, class: 'not'})
        }
        for (let i = 1; i <= 33 - new Date(date.getFullYear(), date.getMonth(), 33).getDate(); i++) {
          let type = ''
          if (this.fromDate) {
            if (date.getMonth() === this.fromDate.getMonth() && date.getFullYear() === this.fromDate.getFullYear() && this.fromDate.getDate() === i) {
              type = 'active'
            }
          }
          days.push({day: i, class: type})
        }
        // Set Next Month Days
        const endDate = new Date(date.getFullYear(), date.getMonth(), days[days.length - 1].day)
        for (let i = 0; i < 6 - (endDate.getDay() === 0 ? 6 : endDate.getDay() - 1); i++) {
          days.push({day: i + 1, class: 'not'})
        }
        return days
      }
    }
  },
  mounted () {
    // set default date
    if (this.data.value) {
      this.date = new Date(Number(this.data.value))
      this.fromDate = new Date(Number(this.data.value))
    } else {
      this.date = new Date()
    }

    // set from days
    this.fromDays = this.getDays(this.date)

    this.rand = 'datepicker_' + Math.floor(Math.random() * (9999999999 - 1000000000) + 1000000000)
    window.addEventListener('click', (e) => {
      if (!e.target.closest(`#${this.rand}`)) {
        this.open = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.datepicker{
  @include box(100%, 3.5vw, relative);
  @include flex(center, center, column);
  @include padding(0, 1vw, 0, 0);
  .title{
    @include box(100%, 2.5vw, absolute, 0, 1vw, null, null, 0, null);
    @include text(0.85vw, 400, null, null, left, $inputLabel);
    @include flex(left, center, row);
  }
  .selectable{
    @include box(100%, 2.5vw, relative, 0, 0, null, null, 0, $input);
    @include border(null, solid, $inputBorder, null, null, null, 0.06vw);
    @include flex(left, center, row);
    z-index: 2;
    span{
      @include box(100%, 100%, relative, 0, 0, null, null, null, null);
      @include text(0.8vw, 400, null, null, left, $inputColor);
      @include flex(left, center, row);
      cursor: pointer;
    }
    .icon{
      @include box(0.9vw, 0.9vw, absolute, null, null, 0, null, null, null);
      cursor: pointer;
    }
    &.focus + .title{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
    &.notnull + .title{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
  }
  &.label{
    @include box(100%, auto, relative);
    @include padding(0, 0, 0, 0);
    .selectable{
      @include box(100%, 2vw, relative, 0, 0, null, null, 0, $input);
    }
  }
  .calendar{
    @include box(16vw, auto, absolute, 0, calc(100% + 0.5vw), null, null, 0.3vw, #FFF);
    @include border(0.04vw, solid, blue);
    z-index: 99;
    &.right{
      left: auto;
      right: 0;
    }
    .header{
      @include box(100%, auto, relative);
      @include padding(0.8vw, 0.8vw, 0.8vw, 0.8vw);
      @include flex(left, center, row);
      @include border(null, solid, blue, null, null, null, 0.04vw);
      .month{
        @include box(100%, auto, relative);
        @include text(0.7vw, 600);
      }
      .controll{
        @include box(auto, auto, relative);
        @include flex(left, center, row);
        flex-shrink: 0;
        .icon{
          @include size(0.7vw, 0.7vw);
          @include margin(1vw, null, null, null);
          cursor: pointer;
        }
      }
    }
    .weeks{
      @include box(100%, auto, relative);
      @include flex(left, center, row);
      @include padding(0.8vw, 0, 0.8vw, 0);
      div{
        @include box(14.28%, 2.5vw, relative);
        @include flex(center, center, row);
        @include text(0.7vw, 700, null, null, center, null);
      }
    }
    .days{
      @include box(100%, auto, relative);
      @include flex(left, center, row);
      @include padding(0.8vw, 0.5vw, 0.8vw, 0.8vw);
      flex-wrap: wrap;
      div{
        @include box(14.28%, 2vw, relative, null, null, null, null, 50%);
        @include flex(center, center, row);
        @include padding(0.1vw, 0.1vw, 0.1vw, 0.1vw);
        span{
          @include box(100%, 100%, relative, null, null, null, null, 50%, null);
          @include flex(center, center, row);
          @include text(0.7vw, 500, null, null, center, null);
          transition: 0.2s;
          cursor: pointer;
          &:hover{
            @include box(none, none, relative, null, null, null, null, null, blue);
            @include text(null, null, null, null, center, white);
          }
        }
        &.not{
          span{
            @include box(none, none, relative, null, null, null, null, null, transparent);
            @include text(null, null, null, null, center, indigo);
            opacity: 0.2;
            cursor: default;
          }
        }
        &.active{
          span{
            @include box(none, none, relative, null, null, null, null, null, blue);
            @include text(null, null, null, null, center, white);
            cursor: default;
          }
        }
      }
    }
  }
}
</style>
